
export enum MoveMethod {
  PAN,
  ZOOM,
  FLY,
}
